// All `states` entries in this dataset represent
// Dewan Rakyat parliamentary seats ONLY (Federal Legislative Council for 1955).
//
// No state assembly election results are included.
//
// `states[].seats` = parliamentary constituencies in that state during that
// specific general election. Generated by scripts/build-historicge.js from
// constituency-level CSVs at electiondata.my; do not edit by hand.

export const malaysiaParliamentaryElectionHistory = [
  {
    year: 1955,
    parliament: "Federal Legislative Council",
    totalSeats: 52,
    winningCoalition: "Alliance",
    coalitionColors: {
      Alliance: "#000080",
      Others: "#F5F5F5"
    },
    coalitions: {
      Alliance: [
        "MCA",
        "MIC",
        "UMNO"
      ],
      Others: [
        "PAS"
      ]
    },
    nationalTotals: {
      Alliance: 51,
      PAS: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 30936,
          ballotsIssued: 27173,
          ballotsNotReturned: 0,
          validVotes: 26583,
          rejectedVotes: 590,
          turnout: 87.84
        }
      },
      {
        name: "Kedah",
        seats: 6,
        breakdown: {
          MCA: 2,
          UMNO: 4
        },
        voting: {
          registered: 193789,
          ballotsIssued: 169424,
          ballotsNotReturned: 0,
          validVotes: 166223,
          rejectedVotes: 3201,
          turnout: 87.43
        }
      },
      {
        name: "Kelantan",
        seats: 5,
        breakdown: {
          UMNO: 5
        },
        voting: {
          registered: 205743,
          ballotsIssued: 172595,
          ballotsNotReturned: 0,
          validVotes: 167129,
          rejectedVotes: 5466,
          turnout: 83.89
        }
      },
      {
        name: "Terengganu",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 90032,
          ballotsIssued: 70680,
          ballotsNotReturned: 0,
          validVotes: 67664,
          rejectedVotes: 3016,
          turnout: 78.51
        }
      },
      {
        name: "Pulau Pinang",
        seats: 4,
        breakdown: {
          UMNO: 2,
          MCA: 2
        },
        voting: {
          registered: 99726,
          ballotsIssued: 48091,
          ballotsNotReturned: 0,
          validVotes: 47342,
          rejectedVotes: 749,
          turnout: 48.22
        }
      },
      {
        name: "Perak",
        seats: 10,
        breakdown: {
          PAS: 1,
          UMNO: 5,
          MCA: 3,
          MIC: 1
        },
        voting: {
          registered: 201364,
          ballotsIssued: 168376,
          ballotsNotReturned: 0,
          validVotes: 163054,
          rejectedVotes: 5322,
          turnout: 83.62
        }
      },
      {
        name: "Pahang",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 64952,
          ballotsIssued: 53346,
          ballotsNotReturned: 0,
          validVotes: 52175,
          rejectedVotes: 1171,
          turnout: 82.13
        }
      },
      {
        name: "Selangor",
        seats: 7,
        breakdown: {
          MCA: 3,
          UMNO: 4
        },
        voting: {
          registered: 85437,
          ballotsIssued: 71913,
          ballotsNotReturned: 0,
          validVotes: 70484,
          rejectedVotes: 1429,
          turnout: 84.17
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 3,
        breakdown: {
          UMNO: 2,
          MCA: 1
        },
        voting: {
          registered: 58132,
          ballotsIssued: 50533,
          ballotsNotReturned: 0,
          validVotes: 49630,
          rejectedVotes: 903,
          turnout: 86.93
        }
      },
      {
        name: "Melaka",
        seats: 2,
        breakdown: {
          MCA: 1,
          UMNO: 1
        },
        voting: {
          registered: 59715,
          ballotsIssued: 50885,
          ballotsNotReturned: 0,
          validVotes: 49909,
          rejectedVotes: 976,
          turnout: 85.21
        }
      },
      {
        name: "Johor",
        seats: 8,
        breakdown: {
          UMNO: 4,
          MCA: 3,
          MIC: 1
        },
        voting: {
          registered: 178422,
          ballotsIssued: 144134,
          ballotsNotReturned: 0,
          validVotes: 141334,
          rejectedVotes: 2800,
          turnout: 80.78
        }
      }
    ],
    notes: "马来亚独立前最后一次联邦立法议会选举。",
    voting: {
      registered: 1268248,
      ballotsIssued: 1027150,
      ballotsNotReturned: 0,
      validVotes: 1001527,
      rejectedVotes: 25623,
      turnout: 80.99
    }
  },
  {
    year: 1959,
    parliament: "Dewan Rakyat",
    totalSeats: 104,
    winningCoalition: "Alliance",
    coalitionColors: {
      Alliance: "#000080",
      "Socialist Front": "#B22222",
      Others: "#F5F5F5"
    },
    coalitions: {
      Alliance: [
        "MCA",
        "MIC",
        "UMNO"
      ],
      "Socialist Front": [
        "LPM",
        "PR"
      ],
      Others: [
        "MP",
        "NEG",
        "PAS",
        "PPP"
      ]
    },
    nationalTotals: {
      Alliance: 74,
      PAS: 13,
      NEG: 1,
      "Socialist Front": 8,
      Independent: 3,
      PPP: 4,
      MP: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 38355,
          ballotsIssued: 29826,
          ballotsNotReturned: 0,
          validVotes: 29603,
          rejectedVotes: 223,
          turnout: 77.76
        }
      },
      {
        name: "Kedah",
        seats: 12,
        breakdown: {
          UMNO: 10,
          MCA: 2
        },
        voting: {
          registered: 264575,
          ballotsIssued: 198428,
          ballotsNotReturned: 0,
          validVotes: 195947,
          rejectedVotes: 2481,
          turnout: 75
        }
      },
      {
        name: "Kelantan",
        seats: 10,
        breakdown: {
          PAS: 9,
          UMNO: 1
        },
        voting: {
          registered: 240552,
          ballotsIssued: 171207,
          ballotsNotReturned: 0,
          validVotes: 169761,
          rejectedVotes: 1446,
          turnout: 71.17
        }
      },
      {
        name: "Terengganu",
        seats: 6,
        breakdown: {
          PAS: 4,
          NEG: 1,
          UMNO: 1
        },
        voting: {
          registered: 114898,
          ballotsIssued: 68337,
          ballotsNotReturned: 0,
          validVotes: 67439,
          rejectedVotes: 898,
          turnout: 59.48
        }
      },
      {
        name: "Pulau Pinang",
        seats: 8,
        breakdown: {
          MCA: 2,
          UMNO: 3,
          LPM: 3
        },
        voting: {
          registered: 188668,
          ballotsIssued: 138141,
          ballotsNotReturned: 0,
          validVotes: 136783,
          rejectedVotes: 1358,
          turnout: 73.22
        }
      },
      {
        name: "Perak",
        seats: 20,
        breakdown: {
          UMNO: 9,
          MCA: 5,
          MIC: 1,
          Independent: 1,
          PPP: 4
        },
        voting: {
          registered: 449969,
          ballotsIssued: 314361,
          ballotsNotReturned: 0,
          validVotes: 310480,
          rejectedVotes: 3881,
          turnout: 69.86
        }
      },
      {
        name: "Pahang",
        seats: 6,
        breakdown: {
          UMNO: 5,
          MCA: 1
        },
        voting: {
          registered: 109535,
          ballotsIssued: 79681,
          ballotsNotReturned: 0,
          validVotes: 78891,
          rejectedVotes: 790,
          turnout: 72.74
        }
      },
      {
        name: "Selangor",
        seats: 14,
        breakdown: {
          UMNO: 5,
          LPM: 3,
          PR: 2,
          MCA: 3,
          MIC: 1
        },
        voting: {
          registered: 271360,
          ballotsIssued: 199820,
          ballotsNotReturned: 0,
          validVotes: 197561,
          rejectedVotes: 2259,
          turnout: 73.64
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 6,
        breakdown: {
          UMNO: 3,
          Independent: 2,
          MIC: 1
        },
        voting: {
          registered: 111336,
          ballotsIssued: 73403,
          ballotsNotReturned: 0,
          validVotes: 72647,
          rejectedVotes: 756,
          turnout: 65.93
        }
      },
      {
        name: "Melaka",
        seats: 4,
        breakdown: {
          MCA: 1,
          MP: 1,
          UMNO: 2
        },
        voting: {
          registered: 93737,
          ballotsIssued: 75344,
          ballotsNotReturned: 0,
          validVotes: 74664,
          rejectedVotes: 680,
          turnout: 80.38
        }
      },
      {
        name: "Johor",
        seats: 16,
        breakdown: {
          UMNO: 11,
          MCA: 5
        },
        voting: {
          registered: 291230,
          ballotsIssued: 216027,
          ballotsNotReturned: 0,
          validVotes: 213493,
          rejectedVotes: 2534,
          turnout: 74.18
        }
      }
    ],
    notes: "马来亚独立后的首次大选。",
    voting: {
      registered: 2174215,
      ballotsIssued: 1564575,
      ballotsNotReturned: 0,
      validVotes: 1547269,
      rejectedVotes: 17306,
      turnout: 71.96
    }
  },
  {
    year: 1964,
    parliament: "Dewan Rakyat",
    totalSeats: 104,
    winningCoalition: "Alliance",
    coalitionColors: {
      Alliance: "#000080",
      "Socialist Front": "#B22222",
      Others: "#F5F5F5"
    },
    coalitions: {
      Alliance: [
        "MCA",
        "MIC",
        "UMNO"
      ],
      "Socialist Front": [
        "LPM"
      ],
      Others: [
        "PAP",
        "PAS",
        "PPP",
        "UDP"
      ]
    },
    nationalTotals: {
      Alliance: 89,
      PAS: 9,
      UDP: 1,
      "Socialist Front": 2,
      PPP: 2,
      PAP: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 46491,
          ballotsIssued: 37940,
          ballotsNotReturned: 0,
          validVotes: 36376,
          rejectedVotes: 1564,
          turnout: 81.61
        }
      },
      {
        name: "Kedah",
        seats: 12,
        breakdown: {
          UMNO: 10,
          MCA: 2
        },
        voting: {
          registered: 336858,
          ballotsIssued: 257472,
          ballotsNotReturned: 0,
          validVotes: 246499,
          rejectedVotes: 10973,
          turnout: 76.43
        }
      },
      {
        name: "Kelantan",
        seats: 10,
        breakdown: {
          PAS: 8,
          UMNO: 2
        },
        voting: {
          registered: 271711,
          ballotsIssued: 217769,
          ballotsNotReturned: 0,
          validVotes: 208894,
          rejectedVotes: 8875,
          turnout: 80.15
        }
      },
      {
        name: "Terengganu",
        seats: 6,
        breakdown: {
          PAS: 1,
          UMNO: 5
        },
        voting: {
          registered: 145217,
          ballotsIssued: 112338,
          ballotsNotReturned: 0,
          validVotes: 107552,
          rejectedVotes: 4786,
          turnout: 77.36
        }
      },
      {
        name: "Pulau Pinang",
        seats: 8,
        breakdown: {
          MCA: 2,
          UMNO: 4,
          UDP: 1,
          LPM: 1
        },
        voting: {
          registered: 253455,
          ballotsIssued: 211548,
          ballotsNotReturned: 0,
          validVotes: 205646,
          rejectedVotes: 5902,
          turnout: 83.47
        }
      },
      {
        name: "Perak",
        seats: 20,
        breakdown: {
          UMNO: 9,
          MCA: 8,
          MIC: 1,
          PPP: 2
        },
        voting: {
          registered: 524487,
          ballotsIssued: 417120,
          ballotsNotReturned: 0,
          validVotes: 399776,
          rejectedVotes: 17344,
          turnout: 79.53
        }
      },
      {
        name: "Pahang",
        seats: 6,
        breakdown: {
          UMNO: 5,
          MCA: 1
        },
        voting: {
          registered: 141592,
          ballotsIssued: 109914,
          ballotsNotReturned: 0,
          validVotes: 104556,
          rejectedVotes: 5358,
          turnout: 77.63
        }
      },
      {
        name: "Selangor",
        seats: 14,
        breakdown: {
          UMNO: 6,
          LPM: 1,
          MCA: 5,
          PAP: 1,
          MIC: 1
        },
        voting: {
          registered: 388211,
          ballotsIssued: 284565,
          ballotsNotReturned: 0,
          validVotes: 270984,
          rejectedVotes: 13581,
          turnout: 73.3
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 6,
        breakdown: {
          UMNO: 3,
          MCA: 2,
          MIC: 1
        },
        voting: {
          registered: 152114,
          ballotsIssued: 121711,
          ballotsNotReturned: 0,
          validVotes: 116163,
          rejectedVotes: 5548,
          turnout: 80.01
        }
      },
      {
        name: "Melaka",
        seats: 4,
        breakdown: {
          MCA: 2,
          UMNO: 2
        },
        voting: {
          registered: 125585,
          ballotsIssued: 105788,
          ballotsNotReturned: 0,
          validVotes: 102596,
          rejectedVotes: 3192,
          turnout: 84.24
        }
      },
      {
        name: "Johor",
        seats: 16,
        breakdown: {
          UMNO: 11,
          MCA: 5
        },
        voting: {
          registered: 377336,
          ballotsIssued: 270443,
          ballotsNotReturned: 0,
          validVotes: 258462,
          rejectedVotes: 11981,
          turnout: 71.67
        }
      }
    ],
    notes: "马来西亚成立后的首次大选。本数据仅涵盖马来半岛104席民选议席；沙巴（16席）与砂拉越（24席）的国会议员由各自州议会间接产生，新加坡的15席则由人民行动党（PAP）通过1963年新加坡州选举包办；新加坡于1965年8月退出联邦。",
    voting: {
      registered: 2763057,
      ballotsIssued: 2146608,
      ballotsNotReturned: 0,
      validVotes: 2057504,
      rejectedVotes: 89104,
      turnout: 77.69
    }
  },
  {
    year: 1969,
    parliament: "Dewan Rakyat",
    totalSeats: 144,
    winningCoalition: "Alliance",
    coalitionColors: {
      Alliance: "#000080",
      Others: "#F5F5F5"
    },
    coalitions: {
      Alliance: [
        "MCA",
        "MIC",
        "PBRS",
        "SCA",
        "UMNO",
        "USNO"
      ],
      Others: [
        "DAP",
        "Gerakan",
        "PAS",
        "PESAKA",
        "PPP",
        "SNAP",
        "SUPP"
      ]
    },
    nationalTotals: {
      Alliance: 90,
      PAS: 12,
      Gerakan: 8,
      DAP: 13,
      PPP: 4,
      SUPP: 5,
      SNAP: 9,
      PESAKA: 2,
      Independent: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 56060,
          ballotsIssued: 44982,
          ballotsNotReturned: 0,
          validVotes: 43391,
          rejectedVotes: 1591,
          turnout: 80.24
        }
      },
      {
        name: "Kedah",
        seats: 12,
        breakdown: {
          UMNO: 7,
          PAS: 3,
          MCA: 2
        },
        voting: {
          registered: 388167,
          ballotsIssued: 293373,
          ballotsNotReturned: 0,
          validVotes: 282240,
          rejectedVotes: 11133,
          turnout: 75.58
        }
      },
      {
        name: "Kelantan",
        seats: 10,
        breakdown: {
          UMNO: 4,
          PAS: 6
        },
        voting: {
          registered: 333754,
          ballotsIssued: 248863,
          ballotsNotReturned: 0,
          validVotes: 241237,
          rejectedVotes: 7626,
          turnout: 74.56
        }
      },
      {
        name: "Terengganu",
        seats: 6,
        breakdown: {
          UMNO: 4,
          PAS: 2
        },
        voting: {
          registered: 179365,
          ballotsIssued: 134620,
          ballotsNotReturned: 0,
          validVotes: 127861,
          rejectedVotes: 6759,
          turnout: 75.05
        }
      },
      {
        name: "Pulau Pinang",
        seats: 8,
        breakdown: {
          MCA: 1,
          Gerakan: 5,
          DAP: 1,
          UMNO: 1
        },
        voting: {
          registered: 282401,
          ballotsIssued: 199671,
          ballotsNotReturned: 0,
          validVotes: 187811,
          rejectedVotes: 11860,
          turnout: 70.7
        }
      },
      {
        name: "Perak",
        seats: 20,
        breakdown: {
          UMNO: 7,
          Gerakan: 1,
          MIC: 1,
          PAS: 1,
          PPP: 4,
          DAP: 5,
          MCA: 1
        },
        voting: {
          registered: 613572,
          ballotsIssued: 448036,
          ballotsNotReturned: 0,
          validVotes: 425981,
          rejectedVotes: 22055,
          turnout: 73.02
        }
      },
      {
        name: "Pahang",
        seats: 6,
        breakdown: {
          UMNO: 5,
          MCA: 1
        },
        voting: {
          registered: 176768,
          ballotsIssued: 84645,
          ballotsNotReturned: 0,
          validVotes: 79729,
          rejectedVotes: 4916,
          turnout: 47.88
        }
      },
      {
        name: "Selangor",
        seats: 14,
        breakdown: {
          UMNO: 6,
          Gerakan: 2,
          DAP: 3,
          MIC: 1,
          MCA: 2
        },
        voting: {
          registered: 516982,
          ballotsIssued: 340021,
          ballotsNotReturned: 0,
          validVotes: 320935,
          rejectedVotes: 19086,
          turnout: 65.77
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 6,
        breakdown: {
          UMNO: 3,
          DAP: 3
        },
        voting: {
          registered: 170728,
          ballotsIssued: 106867,
          ballotsNotReturned: 0,
          validVotes: 99844,
          rejectedVotes: 7023,
          turnout: 62.59
        }
      },
      {
        name: "Melaka",
        seats: 4,
        breakdown: {
          MCA: 1,
          DAP: 1,
          UMNO: 2
        },
        voting: {
          registered: 147765,
          ballotsIssued: 109972,
          ballotsNotReturned: 0,
          validVotes: 105771,
          rejectedVotes: 4201,
          turnout: 74.42
        }
      },
      {
        name: "Johor",
        seats: 16,
        breakdown: {
          UMNO: 11,
          MCA: 5
        },
        voting: {
          registered: 436620,
          ballotsIssued: 208987,
          ballotsNotReturned: 0,
          validVotes: 196482,
          rejectedVotes: 12505,
          turnout: 47.86
        }
      },
      {
        name: "Sabah",
        seats: 16,
        breakdown: {
          USNO: 13,
          SCA: 3
        },
        voting: {
          registered: 208861,
          ballotsIssued: 46031,
          ballotsNotReturned: 0,
          validVotes: 44573,
          rejectedVotes: 1458,
          turnout: 22.04
        }
      },
      {
        name: "Sarawak",
        seats: 24,
        breakdown: {
          SUPP: 5,
          PBRS: 5,
          SNAP: 9,
          SCA: 2,
          PESAKA: 2,
          Independent: 1
        },
        voting: {
          registered: 332737,
          ballotsIssued: 265013,
          ballotsNotReturned: 0,
          validVotes: 240981,
          rejectedVotes: 24032,
          turnout: 79.65
        }
      }
    ],
    notes: "联盟党虽保住政权，但失去三分之二多数。513事件后国会暂时中止。",
    voting: {
      registered: 3843780,
      ballotsIssued: 2531081,
      ballotsNotReturned: 0,
      validVotes: 2396836,
      rejectedVotes: 134245,
      turnout: 65.85
    }
  },
  {
    year: 1974,
    parliament: "Dewan Rakyat",
    totalSeats: 154,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "MCA",
        "MIC",
        "PAS",
        "PBB",
        "PPP",
        "SCA",
        "SUPP",
        "UMNO",
        "USNO"
      ],
      Others: [
        "DAP",
        "PEKEMAS",
        "SNAP"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 135,
      DAP: 9,
      PEKEMAS: 1,
      SNAP: 9
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 58721,
          ballotsIssued: 45755,
          ballotsNotReturned: 0,
          validVotes: 43348,
          rejectedVotes: 2407,
          turnout: 77.92
        }
      },
      {
        name: "Kedah",
        seats: 13,
        breakdown: {
          UMNO: 8,
          PAS: 3,
          MCA: 2
        },
        voting: {
          registered: 400285,
          ballotsIssued: 115605,
          ballotsNotReturned: 0,
          validVotes: 110043,
          rejectedVotes: 5562,
          turnout: 28.88
        }
      },
      {
        name: "Kelantan",
        seats: 12,
        breakdown: {
          UMNO: 5,
          PAS: 7
        },
        voting: {
          registered: 314608,
          ballotsIssued: 155632,
          ballotsNotReturned: 0,
          validVotes: 148068,
          rejectedVotes: 7564,
          turnout: 49.47
        }
      },
      {
        name: "Terengganu",
        seats: 7,
        breakdown: {
          UMNO: 4,
          PAS: 3
        },
        voting: {
          registered: 183604,
          ballotsIssued: 114315,
          ballotsNotReturned: 0,
          validVotes: 107253,
          rejectedVotes: 7062,
          turnout: 62.26
        }
      },
      {
        name: "Pulau Pinang",
        seats: 9,
        breakdown: {
          UMNO: 3,
          MCA: 3,
          Gerakan: 3
        },
        voting: {
          registered: 289140,
          ballotsIssued: 218366,
          ballotsNotReturned: 0,
          validVotes: 209656,
          rejectedVotes: 8710,
          turnout: 75.52
        }
      },
      {
        name: "Perak",
        seats: 21,
        breakdown: {
          UMNO: 10,
          MIC: 1,
          Gerakan: 2,
          DAP: 4,
          PPP: 1,
          MCA: 2,
          PAS: 1
        },
        voting: {
          registered: 626570,
          ballotsIssued: 416565,
          ballotsNotReturned: 0,
          validVotes: 399631,
          rejectedVotes: 16934,
          turnout: 66.48
        }
      },
      {
        name: "Pahang",
        seats: 8,
        breakdown: {
          UMNO: 7,
          MCA: 1
        },
        voting: {
          registered: 199478,
          ballotsIssued: 95893,
          ballotsNotReturned: 0,
          validVotes: 90844,
          rejectedVotes: 5049,
          turnout: 48.07
        }
      },
      {
        name: "Selangor",
        seats: 11,
        breakdown: {
          UMNO: 5,
          MCA: 4,
          MIC: 1,
          DAP: 1
        },
        voting: {
          registered: 338413,
          ballotsIssued: 219413,
          ballotsNotReturned: 0,
          validVotes: 208441,
          rejectedVotes: 10972,
          turnout: 64.84
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 5,
        breakdown: {
          PEKEMAS: 1,
          UMNO: 1,
          MIC: 1,
          DAP: 2
        },
        voting: {
          registered: 173946,
          ballotsIssued: 115769,
          ballotsNotReturned: 0,
          validVotes: 113850,
          rejectedVotes: 1919,
          turnout: 66.55
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 6,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          DAP: 1,
          MIC: 1
        },
        voting: {
          registered: 178717,
          ballotsIssued: 92879,
          ballotsNotReturned: 0,
          validVotes: 87791,
          rejectedVotes: 5088,
          turnout: 51.97
        }
      },
      {
        name: "Melaka",
        seats: 4,
        breakdown: {
          UMNO: 2,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 151699,
          ballotsIssued: 118391,
          ballotsNotReturned: 0,
          validVotes: 113841,
          rejectedVotes: 4550,
          turnout: 78.04
        }
      },
      {
        name: "Johor",
        seats: 16,
        breakdown: {
          UMNO: 11,
          MCA: 5
        },
        voting: {
          registered: 495392,
          ballotsIssued: 218079,
          ballotsNotReturned: 0,
          validVotes: 208725,
          rejectedVotes: 9354,
          turnout: 44.02
        }
      },
      {
        name: "Sabah",
        seats: 16,
        breakdown: {
          USNO: 13,
          SCA: 3
        },
        voting: {
          registered: 230469,
          ballotsIssued: 11069,
          ballotsNotReturned: 0,
          validVotes: 10630,
          rejectedVotes: 439,
          turnout: 4.8
        }
      },
      {
        name: "Sarawak",
        seats: 24,
        breakdown: {
          SNAP: 9,
          SUPP: 7,
          PBB: 8
        },
        voting: {
          registered: 375882,
          ballotsIssued: 282439,
          ballotsNotReturned: 0,
          validVotes: 267782,
          rejectedVotes: 14657,
          turnout: 75.14
        }
      }
    ],
    notes: "国阵（Barisan Nasional）首次以联盟身份参选；伊斯兰党（PAS）当届以国阵成员身份出战。",
    voting: {
      registered: 4016924,
      ballotsIssued: 2220170,
      ballotsNotReturned: 0,
      validVotes: 2119903,
      rejectedVotes: 100267,
      turnout: 55.27
    }
  },
  {
    year: 1978,
    parliament: "Dewan Rakyat",
    totalSeats: 154,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "BERJAYA",
        "Gerakan",
        "MCA",
        "MIC",
        "PBB",
        "SNAP",
        "SUPP",
        "UMNO",
        "USNO"
      ],
      Others: [
        "DAP",
        "PAS",
        "SAPO"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 130,
      PAS: 5,
      DAP: 16,
      Independent: 2,
      SAPO: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 68572,
          ballotsIssued: 52873,
          ballotsNotReturned: 0,
          validVotes: 50641,
          rejectedVotes: 2232,
          turnout: 77.11
        }
      },
      {
        name: "Kedah",
        seats: 13,
        breakdown: {
          UMNO: 9,
          MCA: 2,
          PAS: 2
        },
        voting: {
          registered: 461290,
          ballotsIssued: 356602,
          ballotsNotReturned: 0,
          validVotes: 346503,
          rejectedVotes: 10099,
          turnout: 77.31
        }
      },
      {
        name: "Kelantan",
        seats: 12,
        breakdown: {
          UMNO: 10,
          PAS: 2
        },
        voting: {
          registered: 340411,
          ballotsIssued: 256381,
          ballotsNotReturned: 0,
          validVotes: 253781,
          rejectedVotes: 2600,
          turnout: 75.32
        }
      },
      {
        name: "Terengganu",
        seats: 7,
        breakdown: {
          UMNO: 7
        },
        voting: {
          registered: 207267,
          ballotsIssued: 136096,
          ballotsNotReturned: 0,
          validVotes: 129729,
          rejectedVotes: 6367,
          turnout: 65.66
        }
      },
      {
        name: "Pulau Pinang",
        seats: 9,
        breakdown: {
          UMNO: 2,
          MCA: 1,
          PAS: 1,
          DAP: 4,
          Gerakan: 1
        },
        voting: {
          registered: 383134,
          ballotsIssued: 303541,
          ballotsNotReturned: 0,
          validVotes: 293220,
          rejectedVotes: 10321,
          turnout: 79.23
        }
      },
      {
        name: "Perak",
        seats: 21,
        breakdown: {
          UMNO: 11,
          MIC: 1,
          Gerakan: 2,
          MCA: 3,
          DAP: 4
        },
        voting: {
          registered: 736963,
          ballotsIssued: 569798,
          ballotsNotReturned: 0,
          validVotes: 548671,
          rejectedVotes: 21127,
          turnout: 77.32
        }
      },
      {
        name: "Pahang",
        seats: 8,
        breakdown: {
          UMNO: 6,
          MCA: 2
        },
        voting: {
          registered: 260024,
          ballotsIssued: 194225,
          ballotsNotReturned: 0,
          validVotes: 184928,
          rejectedVotes: 9297,
          turnout: 74.7
        }
      },
      {
        name: "Selangor",
        seats: 11,
        breakdown: {
          UMNO: 6,
          MCA: 3,
          MIC: 1,
          DAP: 1
        },
        voting: {
          registered: 515497,
          ballotsIssued: 383053,
          ballotsNotReturned: 0,
          validVotes: 368430,
          rejectedVotes: 14623,
          turnout: 74.31
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 5,
        breakdown: {
          Gerakan: 1,
          UMNO: 1,
          DAP: 3
        },
        voting: {
          registered: 328216,
          ballotsIssued: 186160,
          ballotsNotReturned: 0,
          validVotes: 184250,
          rejectedVotes: 1910,
          turnout: 56.72
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 6,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          DAP: 1,
          MIC: 1
        },
        voting: {
          registered: 221785,
          ballotsIssued: 148681,
          ballotsNotReturned: 0,
          validVotes: 141775,
          rejectedVotes: 6906,
          turnout: 67.04
        }
      },
      {
        name: "Melaka",
        seats: 4,
        breakdown: {
          UMNO: 2,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 188022,
          ballotsIssued: 110728,
          ballotsNotReturned: 0,
          validVotes: 106300,
          rejectedVotes: 4428,
          turnout: 58.89
        }
      },
      {
        name: "Johor",
        seats: 16,
        breakdown: {
          UMNO: 11,
          MCA: 4,
          DAP: 1
        },
        voting: {
          registered: 615235,
          ballotsIssued: 445413,
          ballotsNotReturned: 0,
          validVotes: 427130,
          rejectedVotes: 18283,
          turnout: 72.4
        }
      },
      {
        name: "Sabah",
        seats: 16,
        breakdown: {
          USNO: 5,
          BERJAYA: 8,
          Independent: 2,
          DAP: 1
        },
        voting: {
          registered: 295880,
          ballotsIssued: 187466,
          ballotsNotReturned: 0,
          validVotes: 181784,
          rejectedVotes: 5682,
          turnout: 63.36
        }
      },
      {
        name: "Sarawak",
        seats: 24,
        breakdown: {
          SNAP: 9,
          SUPP: 6,
          PBB: 8,
          SAPO: 1
        },
        voting: {
          registered: 440276,
          ballotsIssued: 265612,
          ballotsNotReturned: 0,
          validVotes: 256288,
          rejectedVotes: 9324,
          turnout: 60.33
        }
      }
    ],
    voting: {
      registered: 5062572,
      ballotsIssued: 3596629,
      ballotsNotReturned: 0,
      validVotes: 3473430,
      rejectedVotes: 123199,
      turnout: 71.04
    }
  },
  {
    year: 1982,
    parliament: "Dewan Rakyat",
    totalSeats: 154,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "BERJAYA",
        "Gerakan",
        "MCA",
        "MIC",
        "PBB",
        "SNAP",
        "SUPP",
        "UMNO"
      ],
      Others: [
        "DAP",
        "PAS"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 132,
      PAS: 5,
      DAP: 9,
      Independent: 8
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 78973,
          ballotsIssued: 60858,
          ballotsNotReturned: 0,
          validVotes: 58575,
          rejectedVotes: 2283,
          turnout: 77.06
        }
      },
      {
        name: "Kedah",
        seats: 13,
        breakdown: {
          UMNO: 10,
          MCA: 2,
          PAS: 1
        },
        voting: {
          registered: 542014,
          ballotsIssued: 418241,
          ballotsNotReturned: 0,
          validVotes: 406313,
          rejectedVotes: 11928,
          turnout: 77.16
        }
      },
      {
        name: "Kelantan",
        seats: 12,
        breakdown: {
          UMNO: 8,
          PAS: 4
        },
        voting: {
          registered: 418242,
          ballotsIssued: 334810,
          ballotsNotReturned: 0,
          validVotes: 325865,
          rejectedVotes: 8945,
          turnout: 80.05
        }
      },
      {
        name: "Terengganu",
        seats: 7,
        breakdown: {
          UMNO: 7
        },
        voting: {
          registered: 242092,
          ballotsIssued: 193858,
          ballotsNotReturned: 0,
          validVotes: 186147,
          rejectedVotes: 7711,
          turnout: 80.08
        }
      },
      {
        name: "Pulau Pinang",
        seats: 9,
        breakdown: {
          UMNO: 3,
          MCA: 2,
          Gerakan: 2,
          DAP: 2
        },
        voting: {
          registered: 460387,
          ballotsIssued: 354091,
          ballotsNotReturned: 0,
          validVotes: 344345,
          rejectedVotes: 9746,
          turnout: 76.91
        }
      },
      {
        name: "Perak",
        seats: 21,
        breakdown: {
          UMNO: 11,
          MIC: 1,
          Gerakan: 3,
          MCA: 6
        },
        voting: {
          registered: 848917,
          ballotsIssued: 627924,
          ballotsNotReturned: 0,
          validVotes: 607789,
          rejectedVotes: 20135,
          turnout: 73.97
        }
      },
      {
        name: "Pahang",
        seats: 8,
        breakdown: {
          UMNO: 6,
          MCA: 2
        },
        voting: {
          registered: 325831,
          ballotsIssued: 242457,
          ballotsNotReturned: 0,
          validVotes: 233297,
          rejectedVotes: 9160,
          turnout: 74.41
        }
      },
      {
        name: "Selangor",
        seats: 11,
        breakdown: {
          UMNO: 6,
          MCA: 4,
          MIC: 1
        },
        voting: {
          registered: 647791,
          ballotsIssued: 468516,
          ballotsNotReturned: 0,
          validVotes: 454341,
          rejectedVotes: 14175,
          turnout: 72.33
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 5,
        breakdown: {
          DAP: 3,
          UMNO: 1,
          MCA: 1
        },
        voting: {
          registered: 406782,
          ballotsIssued: 288364,
          ballotsNotReturned: 0,
          validVotes: 285125,
          rejectedVotes: 3239,
          turnout: 70.89
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 6,
        breakdown: {
          UMNO: 3,
          MCA: 2,
          MIC: 1
        },
        voting: {
          registered: 261632,
          ballotsIssued: 201646,
          ballotsNotReturned: 0,
          validVotes: 195345,
          rejectedVotes: 6301,
          turnout: 77.07
        }
      },
      {
        name: "Melaka",
        seats: 4,
        breakdown: {
          UMNO: 2,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 219236,
          ballotsIssued: 168408,
          ballotsNotReturned: 0,
          validVotes: 162970,
          rejectedVotes: 5438,
          turnout: 76.82
        }
      },
      {
        name: "Johor",
        seats: 16,
        breakdown: {
          UMNO: 11,
          MIC: 1,
          MCA: 4
        },
        voting: {
          registered: 757837,
          ballotsIssued: 443800,
          ballotsNotReturned: 0,
          validVotes: 424075,
          rejectedVotes: 19725,
          turnout: 58.56
        }
      },
      {
        name: "Sabah",
        seats: 16,
        breakdown: {
          Independent: 5,
          BERJAYA: 10,
          DAP: 1
        },
        voting: {
          registered: 358249,
          ballotsIssued: 217875,
          ballotsNotReturned: 0,
          validVotes: 213712,
          rejectedVotes: 4163,
          turnout: 60.82
        }
      },
      {
        name: "Sarawak",
        seats: 24,
        breakdown: {
          Independent: 3,
          DAP: 2,
          PBB: 8,
          SUPP: 5,
          SNAP: 6
        },
        voting: {
          registered: 513347,
          ballotsIssued: 275454,
          ballotsNotReturned: 0,
          validVotes: 267798,
          rejectedVotes: 7656,
          turnout: 53.66
        }
      }
    ],
    voting: {
      registered: 6081330,
      ballotsIssued: 4296302,
      ballotsNotReturned: 0,
      validVotes: 4165697,
      rejectedVotes: 130605,
      turnout: 70.65
    }
  },
  {
    year: 1986,
    parliament: "Dewan Rakyat",
    totalSeats: 177,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      HAK: "#006400",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "HAMIM",
        "MCA",
        "MIC",
        "PBB",
        "PBDS",
        "PBS",
        "SNAP",
        "SUPP",
        "UMNO",
        "USNO"
      ],
      HAK: [
        "PAS"
      ],
      Others: [
        "DAP"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 148,
      HAK: 1,
      DAP: 24,
      Independent: 4
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 85394,
          ballotsIssued: 62667,
          ballotsNotReturned: 0,
          validVotes: 61107,
          rejectedVotes: 1560,
          turnout: 73.39
        }
      },
      {
        name: "Kedah",
        seats: 14,
        breakdown: {
          UMNO: 12,
          MCA: 2
        },
        voting: {
          registered: 598594,
          ballotsIssued: 436960,
          ballotsNotReturned: 0,
          validVotes: 426424,
          rejectedVotes: 10536,
          turnout: 73
        }
      },
      {
        name: "Kelantan",
        seats: 13,
        breakdown: {
          UMNO: 11,
          PAS: 1,
          HAMIM: 1
        },
        voting: {
          registered: 469828,
          ballotsIssued: 354678,
          ballotsNotReturned: 0,
          validVotes: 346346,
          rejectedVotes: 8332,
          turnout: 75.49
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 8
        },
        voting: {
          registered: 273345,
          ballotsIssued: 215021,
          ballotsNotReturned: 0,
          validVotes: 209154,
          rejectedVotes: 5867,
          turnout: 78.66
        }
      },
      {
        name: "Pulau Pinang",
        seats: 11,
        breakdown: {
          UMNO: 4,
          DAP: 6,
          Gerakan: 1
        },
        voting: {
          registered: 522194,
          ballotsIssued: 381116,
          ballotsNotReturned: 0,
          validVotes: 371613,
          rejectedVotes: 9503,
          turnout: 72.98
        }
      },
      {
        name: "Perak",
        seats: 23,
        breakdown: {
          UMNO: 11,
          Gerakan: 3,
          MIC: 2,
          DAP: 4,
          MCA: 3
        },
        voting: {
          registered: 954180,
          ballotsIssued: 650683,
          ballotsNotReturned: 0,
          validVotes: 631926,
          rejectedVotes: 18757,
          turnout: 68.19
        }
      },
      {
        name: "Pahang",
        seats: 10,
        breakdown: {
          MCA: 3,
          UMNO: 7
        },
        voting: {
          registered: 381100,
          ballotsIssued: 270879,
          ballotsNotReturned: 0,
          validVotes: 262986,
          rejectedVotes: 7893,
          turnout: 71.08
        }
      },
      {
        name: "Selangor",
        seats: 14,
        breakdown: {
          UMNO: 7,
          MIC: 2,
          MCA: 3,
          DAP: 2
        },
        voting: {
          registered: 763914,
          ballotsIssued: 532312,
          ballotsNotReturned: 0,
          validVotes: 515469,
          rejectedVotes: 16843,
          turnout: 69.68
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 7,
        breakdown: {
          DAP: 4,
          Gerakan: 1,
          UMNO: 2
        },
        voting: {
          registered: 473640,
          ballotsIssued: 309301,
          ballotsNotReturned: 0,
          validVotes: 306809,
          rejectedVotes: 2492,
          turnout: 65.3
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 7,
        breakdown: {
          UMNO: 4,
          DAP: 2,
          MIC: 1
        },
        voting: {
          registered: 298660,
          ballotsIssued: 216575,
          ballotsNotReturned: 0,
          validVotes: 210329,
          rejectedVotes: 6246,
          turnout: 72.52
        }
      },
      {
        name: "Melaka",
        seats: 5,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 242913,
          ballotsIssued: 177761,
          ballotsNotReturned: 0,
          validVotes: 172253,
          rejectedVotes: 5508,
          turnout: 73.18
        }
      },
      {
        name: "Johor",
        seats: 18,
        breakdown: {
          MIC: 1,
          UMNO: 12,
          MCA: 5
        },
        voting: {
          registered: 858819,
          ballotsIssued: 548620,
          ballotsNotReturned: 0,
          validVotes: 525317,
          rejectedVotes: 23303,
          turnout: 63.88
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          Independent: 1
        },
        voting: {
          registered: 12171,
          ballotsIssued: 8163,
          ballotsNotReturned: 0,
          validVotes: 8085,
          rejectedVotes: 78,
          turnout: 67.07
        }
      },
      {
        name: "Sabah",
        seats: 20,
        breakdown: {
          Independent: 1,
          PBS: 10,
          DAP: 4,
          USNO: 5
        },
        voting: {
          registered: 423097,
          ballotsIssued: 215735,
          ballotsNotReturned: 0,
          validVotes: 213412,
          rejectedVotes: 2323,
          turnout: 50.99
        }
      },
      {
        name: "Sarawak",
        seats: 24,
        breakdown: {
          SNAP: 5,
          DAP: 1,
          PBB: 8,
          SUPP: 4,
          Independent: 2,
          PBDS: 4
        },
        voting: {
          registered: 607232,
          ballotsIssued: 371533,
          ballotsNotReturned: 0,
          validVotes: 364042,
          rejectedVotes: 7491,
          turnout: 61.18
        }
      }
    ],
    voting: {
      registered: 6965081,
      ballotsIssued: 4752004,
      ballotsNotReturned: 0,
      validVotes: 4625272,
      rejectedVotes: 126732,
      turnout: 68.23
    }
  },
  {
    year: 1990,
    parliament: "Dewan Rakyat",
    totalSeats: 180,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      APU: "#008000",
      "Gagasan Rakyat": "#FF4500"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "MCA",
        "MIC",
        "PBB",
        "PBDS",
        "SNAP",
        "SUPP",
        "UMNO",
        "USNO"
      ],
      APU: [
        "PAS",
        "S46"
      ],
      "Gagasan Rakyat": [
        "DAP",
        "PBS"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 127,
      APU: 15,
      "Gagasan Rakyat": 34,
      Independent: 4
    },
    states: [
      {
        name: "Perlis",
        seats: 2,
        breakdown: {
          UMNO: 2
        },
        voting: {
          registered: 99097,
          ballotsIssued: 76347,
          ballotsNotReturned: 826,
          validVotes: 72977,
          rejectedVotes: 2544,
          turnout: 76.21
        }
      },
      {
        name: "Kedah",
        seats: 14,
        breakdown: {
          UMNO: 12,
          MCA: 2
        },
        voting: {
          registered: 657322,
          ballotsIssued: 498675,
          ballotsNotReturned: 1292,
          validVotes: 482545,
          rejectedVotes: 14838,
          turnout: 75.67
        }
      },
      {
        name: "Kelantan",
        seats: 13,
        breakdown: {
          PAS: 6,
          S46: 7
        },
        voting: {
          registered: 536020,
          ballotsIssued: 421762,
          ballotsNotReturned: 1313,
          validVotes: 410276,
          rejectedVotes: 10173,
          turnout: 78.44
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 6,
          S46: 1,
          PAS: 1
        },
        voting: {
          registered: 326393,
          ballotsIssued: 269529,
          ballotsNotReturned: 846,
          validVotes: 261620,
          rejectedVotes: 7063,
          turnout: 82.32
        }
      },
      {
        name: "Pulau Pinang",
        seats: 11,
        breakdown: {
          UMNO: 4,
          DAP: 6,
          Gerakan: 1
        },
        voting: {
          registered: 559223,
          ballotsIssued: 429940,
          ballotsNotReturned: 1868,
          validVotes: 418701,
          rejectedVotes: 9371,
          turnout: 76.55
        }
      },
      {
        name: "Perak",
        seats: 23,
        breakdown: {
          UMNO: 11,
          Gerakan: 3,
          MIC: 2,
          DAP: 4,
          MCA: 3
        },
        voting: {
          registered: 1031381,
          ballotsIssued: 725920,
          ballotsNotReturned: 6099,
          validVotes: 697217,
          rejectedVotes: 22604,
          turnout: 69.79
        }
      },
      {
        name: "Pahang",
        seats: 10,
        breakdown: {
          MCA: 3,
          UMNO: 7
        },
        voting: {
          registered: 452997,
          ballotsIssued: 336655,
          ballotsNotReturned: 2197,
          validVotes: 322831,
          rejectedVotes: 11627,
          turnout: 73.83
        }
      },
      {
        name: "Selangor",
        seats: 14,
        breakdown: {
          UMNO: 7,
          MIC: 2,
          MCA: 2,
          DAP: 3
        },
        voting: {
          registered: 922615,
          ballotsIssued: 676065,
          ballotsNotReturned: 2006,
          validVotes: 653058,
          rejectedVotes: 21001,
          turnout: 73.06
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 7,
        breakdown: {
          DAP: 4,
          Gerakan: 1,
          UMNO: 2
        },
        voting: {
          registered: 527834,
          ballotsIssued: 365609,
          ballotsNotReturned: 4739,
          validVotes: 356555,
          rejectedVotes: 4315,
          turnout: 68.37
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 7,
        breakdown: {
          UMNO: 4,
          MCA: 2,
          MIC: 1
        },
        voting: {
          registered: 345468,
          ballotsIssued: 263005,
          ballotsNotReturned: 2574,
          validVotes: 252496,
          rejectedVotes: 7935,
          turnout: 75.38
        }
      },
      {
        name: "Melaka",
        seats: 5,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 265059,
          ballotsIssued: 205238,
          ballotsNotReturned: 383,
          validVotes: 198571,
          rejectedVotes: 6284,
          turnout: 77.29
        }
      },
      {
        name: "Johor",
        seats: 18,
        breakdown: {
          MIC: 1,
          UMNO: 12,
          MCA: 5
        },
        voting: {
          registered: 972171,
          ballotsIssued: 722593,
          ballotsNotReturned: 1712,
          validVotes: 694211,
          rejectedVotes: 26670,
          turnout: 74.15
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 16388,
          ballotsIssued: 12489,
          ballotsNotReturned: 378,
          validVotes: 11946,
          rejectedVotes: 165,
          turnout: 73.9
        }
      },
      {
        name: "Sabah",
        seats: 20,
        breakdown: {
          USNO: 6,
          PBS: 14
        },
        voting: {
          registered: 543614,
          ballotsIssued: 308923,
          ballotsNotReturned: 1399,
          validVotes: 300997,
          rejectedVotes: 6527,
          turnout: 56.57
        }
      },
      {
        name: "Sarawak",
        seats: 27,
        breakdown: {
          SNAP: 3,
          PBB: 10,
          DAP: 2,
          SUPP: 4,
          Independent: 4,
          PBDS: 4
        },
        voting: {
          registered: 703061,
          ballotsIssued: 470541,
          ballotsNotReturned: 3754,
          validVotes: 459216,
          rejectedVotes: 7571,
          turnout: 66.39
        }
      }
    ],
    notes: "四六精神党（S46）联同伊斯兰党、BERJASA与HAMIM组成APU出战；人民阵线（Gagasan Rakyat）则由行动党、沙巴团结党（PBS）与人民党（PRM）组成。PBS其后退出国阵。",
    voting: {
      registered: 7958643,
      ballotsIssued: 5783291,
      ballotsNotReturned: 31386,
      validVotes: 5593217,
      rejectedVotes: 158688,
      turnout: 72.27
    }
  },
  {
    year: 1995,
    parliament: "Dewan Rakyat",
    totalSeats: 192,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      APU: "#008000",
      "Gagasan Rakyat": "#FF4500"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "LDP",
        "MCA",
        "MIC",
        "PBB",
        "PBDS",
        "SAPP",
        "SNAP",
        "SUPP",
        "UMNO"
      ],
      APU: [
        "PAS",
        "S46"
      ],
      "Gagasan Rakyat": [
        "DAP",
        "PBS"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 162,
      APU: 13,
      "Gagasan Rakyat": 17
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 104198,
          ballotsIssued: 79348,
          ballotsNotReturned: 845,
          validVotes: 75759,
          rejectedVotes: 2744,
          turnout: 75.34
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          UMNO: 13,
          MCA: 2
        },
        voting: {
          registered: 744758,
          ballotsIssued: 535958,
          ballotsNotReturned: 3737,
          validVotes: 512858,
          rejectedVotes: 19363,
          turnout: 71.46
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 6,
          S46: 6,
          UMNO: 2
        },
        voting: {
          registered: 608502,
          ballotsIssued: 460840,
          ballotsNotReturned: 2500,
          validVotes: 440648,
          rejectedVotes: 17692,
          turnout: 75.32
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 7,
          PAS: 1
        },
        voting: {
          registered: 367676,
          ballotsIssued: 297715,
          ballotsNotReturned: 908,
          validVotes: 286988,
          rejectedVotes: 9819,
          turnout: 80.73
        }
      },
      {
        name: "Pulau Pinang",
        seats: 11,
        breakdown: {
          UMNO: 4,
          DAP: 3,
          MCA: 2,
          Gerakan: 2
        },
        voting: {
          registered: 634726,
          ballotsIssued: 483704,
          ballotsNotReturned: 1315,
          validVotes: 470338,
          rejectedVotes: 12051,
          turnout: 76
        }
      },
      {
        name: "Perak",
        seats: 23,
        breakdown: {
          UMNO: 11,
          Gerakan: 3,
          MIC: 2,
          MCA: 7
        },
        voting: {
          registered: 1115628,
          ballotsIssued: 727147,
          ballotsNotReturned: 10248,
          validVotes: 689561,
          rejectedVotes: 27338,
          turnout: 64.26
        }
      },
      {
        name: "Pahang",
        seats: 11,
        breakdown: {
          UMNO: 8,
          MCA: 3
        },
        voting: {
          registered: 498239,
          ballotsIssued: 367196,
          ballotsNotReturned: 6547,
          validVotes: 345055,
          rejectedVotes: 15594,
          turnout: 72.38
        }
      },
      {
        name: "Selangor",
        seats: 17,
        breakdown: {
          UMNO: 8,
          MIC: 3,
          MCA: 6
        },
        voting: {
          registered: 1093358,
          ballotsIssued: 734580,
          ballotsNotReturned: 4662,
          validVotes: 705088,
          rejectedVotes: 24830,
          turnout: 66.76
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 10,
        breakdown: {
          DAP: 4,
          Gerakan: 2,
          UMNO: 3,
          MCA: 1
        },
        voting: {
          registered: 591896,
          ballotsIssued: 407157,
          ballotsNotReturned: 8212,
          validVotes: 394171,
          rejectedVotes: 4774,
          turnout: 67.4
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 7,
        breakdown: {
          UMNO: 4,
          MCA: 2,
          MIC: 1
        },
        voting: {
          registered: 381887,
          ballotsIssued: 280790,
          ballotsNotReturned: 3263,
          validVotes: 266821,
          rejectedVotes: 10706,
          turnout: 72.67
        }
      },
      {
        name: "Melaka",
        seats: 5,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 292855,
          ballotsIssued: 225571,
          ballotsNotReturned: 1760,
          validVotes: 215801,
          rejectedVotes: 8010,
          turnout: 76.42
        }
      },
      {
        name: "Johor",
        seats: 20,
        breakdown: {
          MIC: 1,
          UMNO: 13,
          MCA: 6
        },
        voting: {
          registered: 1108335,
          ballotsIssued: 812474,
          ballotsNotReturned: 3843,
          validVotes: 772856,
          rejectedVotes: 35775,
          turnout: 72.96
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 20243,
          ballotsIssued: 14007,
          ballotsNotReturned: 649,
          validVotes: 13005,
          rejectedVotes: 353,
          turnout: 65.99
        }
      },
      {
        name: "Sabah",
        seats: 20,
        breakdown: {
          PBS: 8,
          UMNO: 9,
          SAPP: 2,
          LDP: 1
        },
        voting: {
          registered: 646809,
          ballotsIssued: 440950,
          ballotsNotReturned: 1473,
          validVotes: 433691,
          rejectedVotes: 5786,
          turnout: 67.95
        }
      },
      {
        name: "Sarawak",
        seats: 27,
        breakdown: {
          SNAP: 3,
          PBB: 10,
          SUPP: 7,
          PBDS: 6,
          DAP: 1
        },
        voting: {
          registered: 826967,
          ballotsIssued: 387422,
          ballotsNotReturned: 3670,
          validVotes: 376469,
          rejectedVotes: 7283,
          turnout: 46.4
        }
      }
    ],
    voting: {
      registered: 9036077,
      ballotsIssued: 6254859,
      ballotsNotReturned: 53632,
      validVotes: 5999109,
      rejectedVotes: 202118,
      turnout: 68.63
    }
  },
  {
    year: 1999,
    parliament: "Dewan Rakyat",
    totalSeats: 193,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      "Barisan Alternatif": "#008000",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "LDP",
        "MCA",
        "MIC",
        "PBB",
        "PBDS",
        "SAPP",
        "SNAP",
        "SUPP",
        "UMNO",
        "UPKO"
      ],
      "Barisan Alternatif": [
        "DAP",
        "KeADILan",
        "PAS"
      ],
      Others: [
        "PBS"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 148,
      "Barisan Alternatif": 42,
      PBS: 3
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 105733,
          ballotsIssued: 84384,
          ballotsNotReturned: 777,
          validVotes: 82270,
          rejectedVotes: 1337,
          turnout: 79.07
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          UMNO: 5,
          PAS: 8,
          MCA: 2
        },
        voting: {
          registered: 765028,
          ballotsIssued: 585455,
          ballotsNotReturned: 7013,
          validVotes: 566303,
          rejectedVotes: 12139,
          turnout: 75.61
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 10,
          KeADILan: 3,
          UMNO: 1
        },
        voting: {
          registered: 641753,
          ballotsIssued: 492499,
          ballotsNotReturned: 2689,
          validVotes: 480865,
          rejectedVotes: 8945,
          turnout: 76.32
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          PAS: 7,
          KeADILan: 1
        },
        voting: {
          registered: 389071,
          ballotsIssued: 316040,
          ballotsNotReturned: 1093,
          validVotes: 309642,
          rejectedVotes: 5305,
          turnout: 80.95
        }
      },
      {
        name: "Pulau Pinang",
        seats: 11,
        breakdown: {
          UMNO: 3,
          DAP: 4,
          KeADILan: 1,
          Gerakan: 2,
          MCA: 1
        },
        voting: {
          registered: 653572,
          ballotsIssued: 494937,
          ballotsNotReturned: 1968,
          validVotes: 482582,
          rejectedVotes: 10387,
          turnout: 75.43
        }
      },
      {
        name: "Perak",
        seats: 23,
        breakdown: {
          UMNO: 9,
          PAS: 2,
          Gerakan: 3,
          MIC: 2,
          MCA: 6,
          DAP: 1
        },
        voting: {
          registered: 1184070,
          ballotsIssued: 787713,
          ballotsNotReturned: 18831,
          validVotes: 748449,
          rejectedVotes: 20433,
          turnout: 64.94
        }
      },
      {
        name: "Pahang",
        seats: 11,
        breakdown: {
          UMNO: 8,
          MCA: 3
        },
        voting: {
          registered: 522871,
          ballotsIssued: 387551,
          ballotsNotReturned: 6447,
          validVotes: 370584,
          rejectedVotes: 10520,
          turnout: 72.89
        }
      },
      {
        name: "Selangor",
        seats: 17,
        breakdown: {
          UMNO: 8,
          MIC: 3,
          MCA: 6
        },
        voting: {
          registered: 1195278,
          ballotsIssued: 881828,
          ballotsNotReturned: 4081,
          validVotes: 859435,
          rejectedVotes: 18312,
          turnout: 73.43
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 10,
        breakdown: {
          DAP: 4,
          Gerakan: 2,
          UMNO: 3,
          MCA: 1
        },
        voting: {
          registered: 627377,
          ballotsIssued: 452765,
          ballotsNotReturned: 9271,
          validVotes: 439248,
          rejectedVotes: 4246,
          turnout: 70.69
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 7,
        breakdown: {
          UMNO: 4,
          MCA: 2,
          MIC: 1
        },
        voting: {
          registered: 405531,
          ballotsIssued: 298190,
          ballotsNotReturned: 5749,
          validVotes: 283457,
          rejectedVotes: 8984,
          turnout: 72.11
        }
      },
      {
        name: "Melaka",
        seats: 5,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 313686,
          ballotsIssued: 244360,
          ballotsNotReturned: 4331,
          validVotes: 234433,
          rejectedVotes: 5596,
          turnout: 76.52
        }
      },
      {
        name: "Johor",
        seats: 20,
        breakdown: {
          MIC: 1,
          UMNO: 13,
          MCA: 6
        },
        voting: {
          registered: 1190400,
          ballotsIssued: 868757,
          ballotsNotReturned: 6553,
          validVotes: 839187,
          rejectedVotes: 23017,
          turnout: 72.43
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 21611,
          ballotsIssued: 14159,
          ballotsNotReturned: 1806,
          validVotes: 12177,
          rejectedVotes: 176,
          turnout: 57.16
        }
      },
      {
        name: "Sabah",
        seats: 20,
        breakdown: {
          UMNO: 11,
          PBS: 3,
          UPKO: 3,
          SAPP: 2,
          LDP: 1
        },
        voting: {
          registered: 719131,
          ballotsIssued: 444695,
          ballotsNotReturned: 4099,
          validVotes: 435756,
          rejectedVotes: 4840,
          turnout: 61.27
        }
      },
      {
        name: "Sarawak",
        seats: 28,
        breakdown: {
          SNAP: 4,
          PBB: 11,
          SUPP: 7,
          PBDS: 6
        },
        voting: {
          registered: 854902,
          ballotsIssued: 529488,
          ballotsNotReturned: 8270,
          validVotes: 512437,
          rejectedVotes: 8781,
          turnout: 60.97
        }
      }
    ],
    notes: "替代阵线由伊斯兰党、行动党、公正党与人民党组成；行动党其后退出。",
    voting: {
      registered: 9590014,
      ballotsIssued: 6882821,
      ballotsNotReturned: 82978,
      validVotes: 6656825,
      rejectedVotes: 143018,
      turnout: 70.91
    }
  },
  {
    year: 2004,
    parliament: "Dewan Rakyat",
    totalSeats: 219,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      "Barisan Alternatif": "#008000",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "MCA",
        "MIC",
        "MYPPP",
        "PBB",
        "PBDS",
        "PBRS",
        "PBS",
        "SAPP",
        "SPDP",
        "SUPP",
        "UMNO",
        "UPKO"
      ],
      "Barisan Alternatif": [
        "PAS",
        "PKR"
      ],
      Others: [
        "DAP"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 198,
      "Barisan Alternatif": 8,
      DAP: 12,
      Independent: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 112482,
          ballotsIssued: 93610,
          ballotsNotReturned: 537,
          validVotes: 91320,
          rejectedVotes: 1753,
          turnout: 82.74
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          UMNO: 12,
          MCA: 2,
          PAS: 1
        },
        voting: {
          registered: 821901,
          ballotsIssued: 665697,
          ballotsNotReturned: 1007,
          validVotes: 650895,
          rejectedVotes: 13795,
          turnout: 80.87
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 6,
          UMNO: 8
        },
        voting: {
          registered: 662722,
          ballotsIssued: 535063,
          ballotsNotReturned: 1654,
          validVotes: 521501,
          rejectedVotes: 11908,
          turnout: 80.49
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 8
        },
        voting: {
          registered: 455924,
          ballotsIssued: 400894,
          ballotsNotReturned: 2685,
          validVotes: 392020,
          rejectedVotes: 6189,
          turnout: 87.34
        }
      },
      {
        name: "Pulau Pinang",
        seats: 13,
        breakdown: {
          UMNO: 4,
          DAP: 4,
          PKR: 1,
          Gerakan: 3,
          MCA: 1
        },
        voting: {
          registered: 672362,
          ballotsIssued: 511234,
          ballotsNotReturned: 828,
          validVotes: 499694,
          rejectedVotes: 10712,
          turnout: 75.91
        }
      },
      {
        name: "Perak",
        seats: 24,
        breakdown: {
          UMNO: 11,
          Gerakan: 3,
          MYPPP: 1,
          MIC: 2,
          DAP: 3,
          MCA: 4
        },
        voting: {
          registered: 1170351,
          ballotsIssued: 820151,
          ballotsNotReturned: 10412,
          validVotes: 786585,
          rejectedVotes: 23154,
          turnout: 69.19
        }
      },
      {
        name: "Pahang",
        seats: 14,
        breakdown: {
          MIC: 1,
          UMNO: 10,
          MCA: 3
        },
        voting: {
          registered: 570106,
          ballotsIssued: 434367,
          ballotsNotReturned: 2798,
          validVotes: 421254,
          rejectedVotes: 10315,
          turnout: 75.7
        }
      },
      {
        name: "Selangor",
        seats: 22,
        breakdown: {
          UMNO: 10,
          MIC: 4,
          MCA: 7,
          Gerakan: 1
        },
        voting: {
          registered: 1422274,
          ballotsIssued: 1037589,
          ballotsNotReturned: 2734,
          validVotes: 1012719,
          rejectedVotes: 22136,
          turnout: 72.76
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 11,
        breakdown: {
          DAP: 4,
          Gerakan: 2,
          MCA: 2,
          UMNO: 3
        },
        voting: {
          registered: 670920,
          ballotsIssued: 467998,
          ballotsNotReturned: 3081,
          validVotes: 461188,
          rejectedVotes: 3729,
          turnout: 69.3
        }
      },
      {
        name: "W.P. Putrajaya",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 5079,
          ballotsIssued: 4662,
          ballotsNotReturned: 8,
          validVotes: 4626,
          rejectedVotes: 28,
          turnout: 91.63
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 8,
        breakdown: {
          UMNO: 5,
          MCA: 2,
          MIC: 1
        },
        voting: {
          registered: 429786,
          ballotsIssued: 315293,
          ballotsNotReturned: 2433,
          validVotes: 303002,
          rejectedVotes: 9858,
          turnout: 72.79
        }
      },
      {
        name: "Melaka",
        seats: 6,
        breakdown: {
          UMNO: 4,
          MCA: 2
        },
        voting: {
          registered: 345917,
          ballotsIssued: 273061,
          ballotsNotReturned: 602,
          validVotes: 263910,
          rejectedVotes: 8549,
          turnout: 78.76
        }
      },
      {
        name: "Johor",
        seats: 26,
        breakdown: {
          MIC: 1,
          UMNO: 16,
          MCA: 8,
          Gerakan: 1
        },
        voting: {
          registered: 1249007,
          ballotsIssued: 870744,
          ballotsNotReturned: 2079,
          validVotes: 844218,
          rejectedVotes: 24447,
          turnout: 69.55
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 22006,
          ballotsIssued: 14761,
          ballotsNotReturned: 0,
          validVotes: 14273,
          rejectedVotes: 488,
          turnout: 67.08
        }
      },
      {
        name: "Sabah",
        seats: 25,
        breakdown: {
          UMNO: 13,
          PBS: 4,
          UPKO: 4,
          SAPP: 2,
          PBRS: 1,
          Independent: 1
        },
        voting: {
          registered: 768943,
          ballotsIssued: 333248,
          ballotsNotReturned: 2464,
          validVotes: 318799,
          rejectedVotes: 11985,
          turnout: 43.02
        }
      },
      {
        name: "Sarawak",
        seats: 28,
        breakdown: {
          SPDP: 4,
          PBB: 11,
          DAP: 1,
          SUPP: 6,
          PBDS: 6
        },
        voting: {
          registered: 904791,
          ballotsIssued: 431844,
          ballotsNotReturned: 2023,
          validVotes: 423536,
          rejectedVotes: 6285,
          turnout: 47.51
        }
      }
    ],
    voting: {
      registered: 10284571,
      ballotsIssued: 7210216,
      ballotsNotReturned: 35345,
      validVotes: 7009540,
      rejectedVotes: 165331,
      turnout: 69.76
    }
  },
  {
    year: 2008,
    parliament: "Dewan Rakyat",
    totalSeats: 222,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      "Pakatan Rakyat": "#FF8C00"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "LDP",
        "MCA",
        "MIC",
        "PBB",
        "PBRS",
        "PBS",
        "PRS",
        "SAPP",
        "SPDP",
        "SUPP",
        "UMNO",
        "UPKO"
      ],
      "Pakatan Rakyat": [
        "DAP",
        "PAS",
        "PKR",
        "PSM"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 140,
      "Pakatan Rakyat": 82
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 120081,
          ballotsIssued: 97532,
          ballotsNotReturned: 257,
          validVotes: 95207,
          rejectedVotes: 2068,
          turnout: 81.01
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          UMNO: 3,
          PAS: 6,
          MCA: 1,
          PKR: 5
        },
        voting: {
          registered: 873674,
          ballotsIssued: 697225,
          ballotsNotReturned: 2283,
          validVotes: 679469,
          rejectedVotes: 15473,
          turnout: 79.54
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 9,
          PKR: 3,
          UMNO: 2
        },
        voting: {
          registered: 751682,
          ballotsIssued: 620632,
          ballotsNotReturned: 2064,
          validVotes: 607803,
          rejectedVotes: 10765,
          turnout: 82.29
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 7,
          PAS: 1
        },
        voting: {
          registered: 521597,
          ballotsIssued: 443205,
          ballotsNotReturned: 1190,
          validVotes: 435348,
          rejectedVotes: 6667,
          turnout: 84.74
        }
      },
      {
        name: "Pulau Pinang",
        seats: 13,
        breakdown: {
          UMNO: 2,
          DAP: 7,
          PKR: 4
        },
        voting: {
          registered: 709323,
          ballotsIssued: 554677,
          ballotsNotReturned: 2876,
          validVotes: 542831,
          rejectedVotes: 8970,
          turnout: 77.79
        }
      },
      {
        name: "Perak",
        seats: 24,
        breakdown: {
          Gerakan: 1,
          UMNO: 8,
          PAS: 2,
          PKR: 2,
          DAP: 6,
          PSM: 1,
          MCA: 3,
          MIC: 1
        },
        voting: {
          registered: 1196160,
          ballotsIssued: 872592,
          ballotsNotReturned: 7527,
          validVotes: 842390,
          rejectedVotes: 22675,
          turnout: 72.32
        }
      },
      {
        name: "Pahang",
        seats: 14,
        breakdown: {
          MIC: 1,
          UMNO: 9,
          MCA: 2,
          PKR: 2
        },
        voting: {
          registered: 603242,
          ballotsIssued: 464908,
          ballotsNotReturned: 2324,
          validVotes: 451114,
          rejectedVotes: 11470,
          turnout: 76.68
        }
      },
      {
        name: "Selangor",
        seats: 22,
        breakdown: {
          UMNO: 4,
          PKR: 9,
          PAS: 4,
          MCA: 1,
          DAP: 4
        },
        voting: {
          registered: 1565493,
          ballotsIssued: 1208673,
          ballotsNotReturned: 4238,
          validVotes: 1178438,
          rejectedVotes: 25997,
          turnout: 76.94
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 11,
        breakdown: {
          DAP: 5,
          PKR: 4,
          UMNO: 1,
          PAS: 1
        },
        voting: {
          registered: 687451,
          ballotsIssued: 506672,
          ballotsNotReturned: 4418,
          validVotes: 497741,
          rejectedVotes: 4513,
          turnout: 73.06
        }
      },
      {
        name: "W.P. Putrajaya",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 6608,
          ballotsIssued: 5416,
          ballotsNotReturned: 36,
          validVotes: 5342,
          rejectedVotes: 38,
          turnout: 81.42
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 8,
        breakdown: {
          UMNO: 5,
          DAP: 2,
          PKR: 1
        },
        voting: {
          registered: 462015,
          ballotsIssued: 353021,
          ballotsNotReturned: 2178,
          validVotes: 341103,
          rejectedVotes: 9740,
          turnout: 75.94
        }
      },
      {
        name: "Melaka",
        seats: 6,
        breakdown: {
          UMNO: 4,
          MCA: 1,
          DAP: 1
        },
        voting: {
          registered: 371594,
          ballotsIssued: 297450,
          ballotsNotReturned: 3103,
          validVotes: 286679,
          rejectedVotes: 7668,
          turnout: 79.21
        }
      },
      {
        name: "Johor",
        seats: 26,
        breakdown: {
          MIC: 1,
          UMNO: 16,
          MCA: 7,
          DAP: 1,
          Gerakan: 1
        },
        voting: {
          registered: 1312121,
          ballotsIssued: 972186,
          ballotsNotReturned: 3082,
          validVotes: 940391,
          rejectedVotes: 28713,
          turnout: 73.86
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 20783,
          ballotsIssued: 14149,
          ballotsNotReturned: 247,
          validVotes: 13591,
          rejectedVotes: 311,
          turnout: 66.89
        }
      },
      {
        name: "Sabah",
        seats: 25,
        breakdown: {
          UMNO: 13,
          PBS: 3,
          UPKO: 4,
          SAPP: 2,
          DAP: 1,
          PBRS: 1,
          LDP: 1
        },
        voting: {
          registered: 807862,
          ballotsIssued: 519559,
          ballotsNotReturned: 2748,
          validVotes: 501113,
          rejectedVotes: 15698,
          turnout: 63.97
        }
      },
      {
        name: "Sarawak",
        seats: 31,
        breakdown: {
          SPDP: 4,
          PBB: 14,
          DAP: 1,
          SUPP: 6,
          PRS: 6
        },
        voting: {
          registered: 912454,
          ballotsIssued: 533155,
          ballotsNotReturned: 2432,
          validVotes: 524243,
          rejectedVotes: 6480,
          turnout: 58.16
        }
      }
    ],
    notes: "国阵自1969年以来首次失去三分之二多数。",
    voting: {
      registered: 10922140,
      ballotsIssued: 8161052,
      ballotsNotReturned: 41003,
      validVotes: 7942803,
      rejectedVotes: 177246,
      turnout: 74.34
    }
  },
  {
    year: 2013,
    parliament: "Dewan Rakyat",
    totalSeats: 222,
    winningCoalition: "Barisan Nasional",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      "Pakatan Rakyat": "#FF8C00"
    },
    coalitions: {
      "Barisan Nasional": [
        "Gerakan",
        "MCA",
        "MIC",
        "PBB",
        "PBRS",
        "PBS",
        "PRS",
        "SPDP",
        "SUPP",
        "UMNO",
        "UPKO"
      ],
      "Pakatan Rakyat": [
        "DAP",
        "PAS",
        "PKR",
        "PSM"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 133,
      "Pakatan Rakyat": 89
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          UMNO: 3
        },
        voting: {
          registered: 137057,
          ballotsIssued: 118012,
          ballotsNotReturned: 333,
          validVotes: 115956,
          rejectedVotes: 1723,
          turnout: 85.86
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          UMNO: 10,
          PAS: 1,
          PKR: 4
        },
        voting: {
          registered: 1041068,
          ballotsIssued: 908320,
          ballotsNotReturned: 2822,
          validVotes: 891575,
          rejectedVotes: 13923,
          turnout: 86.98
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 9,
          UMNO: 5
        },
        voting: {
          registered: 918573,
          ballotsIssued: 782356,
          ballotsNotReturned: 2301,
          validVotes: 769214,
          rejectedVotes: 10841,
          turnout: 84.92
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 4,
          PAS: 4
        },
        voting: {
          registered: 634944,
          ballotsIssued: 559272,
          ballotsNotReturned: 1432,
          validVotes: 551133,
          rejectedVotes: 6707,
          turnout: 87.86
        }
      },
      {
        name: "Pulau Pinang",
        seats: 13,
        breakdown: {
          UMNO: 3,
          DAP: 7,
          PKR: 3
        },
        voting: {
          registered: 846232,
          ballotsIssued: 737561,
          ballotsNotReturned: 1488,
          validVotes: 727244,
          rejectedVotes: 8829,
          turnout: 86.98
        }
      },
      {
        name: "Perak",
        seats: 24,
        breakdown: {
          UMNO: 10,
          PAS: 2,
          DAP: 7,
          PSM: 1,
          PKR: 2,
          MIC: 1,
          MCA: 1
        },
        voting: {
          registered: 1406734,
          ballotsIssued: 1164303,
          ballotsNotReturned: 3506,
          validVotes: 1140876,
          rejectedVotes: 19921,
          turnout: 82.52
        }
      },
      {
        name: "Pahang",
        seats: 14,
        breakdown: {
          MIC: 1,
          UMNO: 8,
          DAP: 1,
          PKR: 2,
          PAS: 1,
          MCA: 1
        },
        voting: {
          registered: 736111,
          ballotsIssued: 625026,
          ballotsNotReturned: 1960,
          validVotes: 611766,
          rejectedVotes: 11300,
          turnout: 84.64
        }
      },
      {
        name: "Selangor",
        seats: 22,
        breakdown: {
          UMNO: 4,
          MIC: 1,
          PKR: 9,
          PAS: 4,
          DAP: 4
        },
        voting: {
          registered: 2048828,
          ballotsIssued: 1789780,
          ballotsNotReturned: 4525,
          validVotes: 1759470,
          rejectedVotes: 25785,
          turnout: 87.14
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 11,
        breakdown: {
          DAP: 5,
          PKR: 4,
          UMNO: 2
        },
        voting: {
          registered: 792071,
          ballotsIssued: 664128,
          ballotsNotReturned: 1259,
          validVotes: 657850,
          rejectedVotes: 5019,
          turnout: 83.69
        }
      },
      {
        name: "W.P. Putrajaya",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 15791,
          ballotsIssued: 14465,
          ballotsNotReturned: 47,
          validVotes: 14345,
          rejectedVotes: 73,
          turnout: 91.31
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 8,
        breakdown: {
          UMNO: 5,
          DAP: 2,
          PKR: 1
        },
        voting: {
          registered: 555982,
          ballotsIssued: 474977,
          ballotsNotReturned: 1430,
          validVotes: 464618,
          rejectedVotes: 8929,
          turnout: 85.17
        }
      },
      {
        name: "Melaka",
        seats: 6,
        breakdown: {
          UMNO: 3,
          MCA: 1,
          PKR: 1,
          DAP: 1
        },
        voting: {
          registered: 439040,
          ballotsIssued: 384162,
          ballotsNotReturned: 847,
          validVotes: 377056,
          rejectedVotes: 6259,
          turnout: 87.31
        }
      },
      {
        name: "Johor",
        seats: 26,
        breakdown: {
          MIC: 1,
          UMNO: 15,
          MCA: 4,
          DAP: 4,
          PKR: 1,
          Gerakan: 1
        },
        voting: {
          registered: 1605311,
          ballotsIssued: 1395763,
          ballotsNotReturned: 2737,
          validVotes: 1366942,
          rejectedVotes: 26084,
          turnout: 86.78
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 24474,
          ballotsIssued: 19377,
          ballotsNotReturned: 21,
          validVotes: 19149,
          rejectedVotes: 207,
          turnout: 79.09
        }
      },
      {
        name: "Sabah",
        seats: 25,
        breakdown: {
          UMNO: 14,
          PBS: 4,
          UPKO: 3,
          DAP: 2,
          PKR: 1,
          PBRS: 1
        },
        voting: {
          registered: 981814,
          ballotsIssued: 790148,
          ballotsNotReturned: 1597,
          validVotes: 770466,
          rejectedVotes: 18085,
          turnout: 80.32
        }
      },
      {
        name: "Sarawak",
        seats: 31,
        breakdown: {
          SPDP: 4,
          PBB: 14,
          DAP: 5,
          SUPP: 1,
          PRS: 6,
          PKR: 1
        },
        voting: {
          registered: 1083972,
          ballotsIssued: 828895,
          ballotsNotReturned: 1692,
          validVotes: 817227,
          rejectedVotes: 9976,
          turnout: 76.31
        }
      }
    ],
    notes: "民联赢得普选多数票，但国阵仍保住国会多数议席。",
    voting: {
      registered: 13268002,
      ballotsIssued: 11256545,
      ballotsNotReturned: 27997,
      validVotes: 11054887,
      rejectedVotes: 173661,
      turnout: 84.63
    }
  },
  {
    year: 2018,
    parliament: "Dewan Rakyat",
    totalSeats: 222,
    winningCoalition: "Pakatan Harapan",
    coalitionColors: {
      "Barisan Nasional": "#000080",
      "Pakatan Harapan": "#ED1C24",
      "Gagasan Sejahtera": "#008000",
      "United Sabah Alliance": "#8B0000",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Barisan Nasional": [
        "MCA",
        "MIC",
        "PBB",
        "PBRS",
        "PBS",
        "PDP",
        "PRS",
        "SUPP",
        "UMNO",
        "UPKO"
      ],
      "Pakatan Harapan": [
        "Amanah",
        "Bersatu",
        "DAP",
        "PKR"
      ],
      "Gagasan Sejahtera": [
        "PAS"
      ],
      "United Sabah Alliance": [
        "STAR"
      ],
      Others: [
        "Warisan"
      ]
    },
    nationalTotals: {
      "Barisan Nasional": 79,
      "Pakatan Harapan": 113,
      "Gagasan Sejahtera": 18,
      Independent: 3,
      Warisan: 8,
      "United Sabah Alliance": 1
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          UMNO: 2,
          PKR: 1
        },
        voting: {
          registered: 150221,
          ballotsIssued: 123568,
          ballotsNotReturned: 512,
          validVotes: 120780,
          rejectedVotes: 2276,
          turnout: 81.92
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          Bersatu: 3,
          UMNO: 2,
          Amanah: 1,
          PKR: 6,
          PAS: 3
        },
        voting: {
          registered: 1146492,
          ballotsIssued: 957310,
          ballotsNotReturned: 3397,
          validVotes: 940302,
          rejectedVotes: 13611,
          turnout: 83.2
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 9,
          UMNO: 5
        },
        voting: {
          registered: 1049527,
          ballotsIssued: 840849,
          ballotsNotReturned: 8036,
          validVotes: 820343,
          rejectedVotes: 12470,
          turnout: 79.35
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          UMNO: 2,
          PAS: 6
        },
        voting: {
          registered: 736632,
          ballotsIssued: 631180,
          ballotsNotReturned: 3081,
          validVotes: 620547,
          rejectedVotes: 7552,
          turnout: 85.27
        }
      },
      {
        name: "Pulau Pinang",
        seats: 13,
        breakdown: {
          UMNO: 2,
          DAP: 7,
          PKR: 4
        },
        voting: {
          registered: 945627,
          ballotsIssued: 800080,
          ballotsNotReturned: 2286,
          validVotes: 789125,
          rejectedVotes: 8669,
          turnout: 84.37
        }
      },
      {
        name: "Perak",
        seats: 24,
        breakdown: {
          UMNO: 10,
          Amanah: 2,
          DAP: 7,
          PKR: 3,
          Bersatu: 1,
          MIC: 1
        },
        voting: {
          registered: 1510864,
          ballotsIssued: 1214412,
          ballotsNotReturned: 6447,
          validVotes: 1189267,
          rejectedVotes: 18698,
          turnout: 79.95
        }
      },
      {
        name: "Pahang",
        seats: 14,
        breakdown: {
          MIC: 1,
          UMNO: 8,
          DAP: 2,
          PKR: 2,
          Amanah: 1
        },
        voting: {
          registered: 823981,
          ballotsIssued: 676492,
          ballotsNotReturned: 3052,
          validVotes: 662570,
          rejectedVotes: 10870,
          turnout: 81.73
        }
      },
      {
        name: "Selangor",
        seats: 22,
        breakdown: {
          UMNO: 2,
          Bersatu: 1,
          PKR: 10,
          Amanah: 5,
          DAP: 4
        },
        voting: {
          registered: 2415074,
          ballotsIssued: 2082179,
          ballotsNotReturned: 6895,
          validVotes: 2055921,
          rejectedVotes: 19363,
          turnout: 85.93
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 11,
        breakdown: {
          DAP: 5,
          Independent: 1,
          PKR: 4,
          Bersatu: 1
        },
        voting: {
          registered: 847793,
          ballotsIssued: 703589,
          ballotsNotReturned: 2626,
          validVotes: 696507,
          rejectedVotes: 4456,
          turnout: 82.68
        }
      },
      {
        name: "W.P. Putrajaya",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 27306,
          ballotsIssued: 24881,
          ballotsNotReturned: 177,
          validVotes: 24558,
          rejectedVotes: 146,
          turnout: 90.47
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 8,
        breakdown: {
          UMNO: 3,
          DAP: 2,
          Bersatu: 1,
          PKR: 1,
          Amanah: 1
        },
        voting: {
          registered: 607793,
          ballotsIssued: 506699,
          ballotsNotReturned: 2122,
          validVotes: 497249,
          rejectedVotes: 7328,
          turnout: 83.02
        }
      },
      {
        name: "Melaka",
        seats: 6,
        breakdown: {
          UMNO: 2,
          Bersatu: 1,
          PKR: 2,
          DAP: 1
        },
        voting: {
          registered: 494662,
          ballotsIssued: 420301,
          ballotsNotReturned: 1358,
          validVotes: 412902,
          rejectedVotes: 6041,
          turnout: 84.69
        }
      },
      {
        name: "Johor",
        seats: 26,
        breakdown: {
          PKR: 7,
          DAP: 5,
          Bersatu: 5,
          UMNO: 7,
          MCA: 1,
          Amanah: 1
        },
        voting: {
          registered: 1817999,
          ballotsIssued: 1535927,
          ballotsNotReturned: 5878,
          validVotes: 1507921,
          rejectedVotes: 22128,
          turnout: 84.16
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          UMNO: 1
        },
        voting: {
          registered: 28356,
          ballotsIssued: 21729,
          ballotsNotReturned: 69,
          validVotes: 21358,
          rejectedVotes: 302,
          turnout: 76.39
        }
      },
      {
        name: "Sabah",
        seats: 25,
        breakdown: {
          UMNO: 7,
          PBS: 1,
          Warisan: 8,
          UPKO: 1,
          DAP: 3,
          PKR: 3,
          STAR: 1,
          PBRS: 1
        },
        voting: {
          registered: 1117337,
          ballotsIssued: 866456,
          ballotsNotReturned: 4088,
          validVotes: 843101,
          rejectedVotes: 19267,
          turnout: 77.18
        }
      },
      {
        name: "Sarawak",
        seats: 31,
        breakdown: {
          DAP: 6,
          PBB: 13,
          PKR: 4,
          SUPP: 1,
          PRS: 3,
          Independent: 2,
          PDP: 2
        },
        voting: {
          registered: 1220960,
          ballotsIssued: 894415,
          ballotsNotReturned: 3560,
          validVotes: 880528,
          rejectedVotes: 10327,
          turnout: 72.96
        }
      }
    ],
    notes: "国阵在联邦层级首次败选。",
    voting: {
      registered: 14940624,
      ballotsIssued: 12300067,
      ballotsNotReturned: 53584,
      validVotes: 12082979,
      rejectedVotes: 163504,
      turnout: 81.97
    }
  },
  {
    year: 2022,
    parliament: "Dewan Rakyat",
    totalSeats: 222,
    winningCoalition: "Unity Government (PH-led)",
    coalitionColors: {
      "Perikatan Nasional": "#003153",
      "Pakatan Harapan": "#ED1C24",
      "Barisan Nasional": "#000080",
      GRS: "#ADD8E6",
      GPS: "#FFD700",
      Others: "#F5F5F5"
    },
    coalitions: {
      "Perikatan Nasional": [
        "Bersatu",
        "PAS"
      ],
      "Pakatan Harapan": [
        "Amanah",
        "DAP",
        "MUDA",
        "PKR",
        "UPKO"
      ],
      "Barisan Nasional": [
        "MCA",
        "MIC",
        "PBRS",
        "UMNO"
      ],
      GRS: [
        "Independent",
        "PBS",
        "STAR"
      ],
      GPS: [
        "PBB",
        "PDP",
        "PRS",
        "SUPP"
      ],
      Others: [
        "KDM",
        "PBM",
        "Warisan"
      ]
    },
    nationalTotals: {
      "Perikatan Nasional": 74,
      "Pakatan Harapan": 82,
      "Barisan Nasional": 30,
      Independent: 2,
      KDM: 1,
      Warisan: 3,
      GRS: 6,
      GPS: 23,
      PBM: 1
    },
    states: [
      {
        name: "Perlis",
        seats: 3,
        breakdown: {
          PAS: 2,
          Bersatu: 1
        },
        voting: {
          registered: 195927,
          ballotsIssued: 150653,
          ballotsNotReturned: 275,
          validVotes: 148277,
          rejectedVotes: 2101,
          turnout: 76.75
        }
      },
      {
        name: "Kedah",
        seats: 15,
        breakdown: {
          Bersatu: 5,
          PAS: 9,
          PKR: 1
        },
        voting: {
          registered: 1575805,
          ballotsIssued: 1223969,
          ballotsNotReturned: 2479,
          validVotes: 1209539,
          rejectedVotes: 11951,
          turnout: 77.52
        }
      },
      {
        name: "Kelantan",
        seats: 14,
        breakdown: {
          PAS: 9,
          Bersatu: 5
        },
        voting: {
          registered: 1404763,
          ballotsIssued: 1006958,
          ballotsNotReturned: 3234,
          validVotes: 992408,
          rejectedVotes: 11316,
          turnout: 71.45
        }
      },
      {
        name: "Terengganu",
        seats: 8,
        breakdown: {
          PAS: 7,
          Bersatu: 1
        },
        voting: {
          registered: 922856,
          ballotsIssued: 748473,
          ballotsNotReturned: 1468,
          validVotes: 739816,
          rejectedVotes: 7189,
          turnout: 80.94
        }
      },
      {
        name: "Pulau Pinang",
        seats: 13,
        breakdown: {
          PAS: 2,
          Bersatu: 1,
          DAP: 7,
          PKR: 3
        },
        voting: {
          registered: 1226626,
          ballotsIssued: 956089,
          ballotsNotReturned: 2273,
          validVotes: 943971,
          rejectedVotes: 9845,
          turnout: 77.76
        }
      },
      {
        name: "Perak",
        seats: 24,
        breakdown: {
          Bersatu: 6,
          UMNO: 2,
          PAS: 4,
          DAP: 7,
          PKR: 4,
          MIC: 1
        },
        voting: {
          registered: 2036872,
          ballotsIssued: 1506442,
          ballotsNotReturned: 4161,
          validVotes: 1482258,
          rejectedVotes: 20023,
          turnout: 73.75
        }
      },
      {
        name: "Pahang",
        seats: 14,
        breakdown: {
          UMNO: 5,
          DAP: 2,
          PAS: 5,
          Bersatu: 2
        },
        voting: {
          registered: 1136944,
          ballotsIssued: 885608,
          ballotsNotReturned: 2129,
          validVotes: 872826,
          rejectedVotes: 10653,
          turnout: 77.71
        }
      },
      {
        name: "Selangor",
        seats: 22,
        breakdown: {
          Bersatu: 3,
          PAS: 3,
          Amanah: 5,
          PKR: 7,
          DAP: 4
        },
        voting: {
          registered: 3677848,
          ballotsIssued: 2962132,
          ballotsNotReturned: 7061,
          validVotes: 2930276,
          rejectedVotes: 24795,
          turnout: 80.35
        }
      },
      {
        name: "W.P. Kuala Lumpur",
        seats: 11,
        breakdown: {
          DAP: 5,
          PKR: 5,
          UMNO: 1
        },
        voting: {
          registered: 1151407,
          ballotsIssued: 862315,
          ballotsNotReturned: 2429,
          validVotes: 855194,
          rejectedVotes: 4692,
          turnout: 74.68
        }
      },
      {
        name: "W.P. Putrajaya",
        seats: 1,
        breakdown: {
          Bersatu: 1
        },
        voting: {
          registered: 42881,
          ballotsIssued: 36969,
          ballotsNotReturned: 158,
          validVotes: 36643,
          rejectedVotes: 168,
          turnout: 85.84
        }
      },
      {
        name: "Negeri Sembilan",
        seats: 8,
        breakdown: {
          UMNO: 5,
          DAP: 2,
          PKR: 1
        },
        voting: {
          registered: 850865,
          ballotsIssued: 667735,
          ballotsNotReturned: 1699,
          validVotes: 659425,
          rejectedVotes: 6611,
          turnout: 78.28
        }
      },
      {
        name: "Melaka",
        seats: 6,
        breakdown: {
          Bersatu: 1,
          Amanah: 1,
          PAS: 2,
          PKR: 1,
          DAP: 1
        },
        voting: {
          registered: 657324,
          ballotsIssued: 520923,
          ballotsNotReturned: 1403,
          validVotes: 515041,
          rejectedVotes: 4479,
          turnout: 79.04
        }
      },
      {
        name: "Johor",
        seats: 26,
        breakdown: {
          PKR: 7,
          DAP: 5,
          Bersatu: 2,
          MUDA: 1,
          UMNO: 7,
          MCA: 2,
          Amanah: 2
        },
        voting: {
          registered: 2616575,
          ballotsIssued: 1975004,
          ballotsNotReturned: 5634,
          validVotes: 1952458,
          rejectedVotes: 16912,
          turnout: 75.27
        }
      },
      {
        name: "W.P. Labuan",
        seats: 1,
        breakdown: {
          Bersatu: 1
        },
        voting: {
          registered: 44484,
          ballotsIssued: 28762,
          ballotsNotReturned: 67,
          validVotes: 28449,
          rejectedVotes: 246,
          turnout: 64.51
        }
      },
      {
        name: "Sabah",
        seats: 25,
        breakdown: {
          Independent: 6,
          KDM: 1,
          Warisan: 3,
          UPKO: 2,
          PKR: 1,
          DAP: 2,
          UMNO: 6,
          STAR: 1,
          PBRS: 1,
          Bersatu: 1,
          PBS: 1
        },
        voting: {
          registered: 1689387,
          ballotsIssued: 1087825,
          ballotsNotReturned: 4303,
          validVotes: 1068532,
          rejectedVotes: 14990,
          turnout: 64.14
        }
      },
      {
        name: "Sarawak",
        seats: 31,
        breakdown: {
          DAP: 5,
          PBB: 14,
          SUPP: 2,
          PRS: 5,
          Bersatu: 1,
          PBM: 1,
          PDP: 2,
          PKR: 1
        },
        voting: {
          registered: 1943074,
          ballotsIssued: 1197450,
          ballotsNotReturned: 4214,
          validVotes: 1178867,
          rejectedVotes: 14369,
          turnout: 61.41
        }
      }
    ],
    notes: "国会悬峙，最终由希望联盟（PH）牵头组成团结政府。",
    voting: {
      registered: 21173638,
      ballotsIssued: 15817307,
      ballotsNotReturned: 42987,
      validVotes: 15613980,
      rejectedVotes: 160340,
      turnout: 74.5
    }
  }
];
